'use strict';

const {
	getInventoryMessage,
	getInventoryMessageCustomerId,
	getInventoryMessageWarehouseId,
	getPickupMessage,
	getShippingEstimateMessage,
	getShippingMessage,
	getShippingMessageTitle,
} = require('public/js/lib/product-message-utils');

function trackWrongCarSelectedIfApplicable($container) {
	const trackingPage = globalThis?.tracking?.page || 'other';
	const $partFitmentInfoElement = $container.find('#part-fitment-info');

	if ($partFitmentInfoElement.length === 0) {
		return;
	}

	const data = $partFitmentInfoElement.data('fitment-info');
	if (data === 'part-doesnt-fit') {
		globalThis.rp_app.track.track_event(['ProductPageWrongCarSelected', 'WrongCarSelected', trackingPage]);
	}
}

function loadInventoryMessages($container) {
	const $inventoryModule = $container.find('.product-inventory-msg');
	if ($inventoryModule.length === 0) {
		return;
	}

	const catalog = $inventoryModule.data('catalog');
	const skuStripped = $inventoryModule.data('sku-stripped');
	const inStock = $inventoryModule.data('in-stock');
	const price = $inventoryModule.data('price');
	const quantity = $inventoryModule.data('quantity');
	const isVariantMaster = $inventoryModule.data('is-variant-master');
	const inventoryWarehouseId = $inventoryModule.data('inventory-warehouse-id');
	const inventoryCustomerId = $inventoryModule.data('inventory-customer-id');

	if (!catalog || !skuStripped || isVariantMaster || !inventoryWarehouseId || !inventoryCustomerId) {
		return;
	}

	$ajax({
		method: 'GET',
		dataType: 'json',
		url: '/ajax/product/get-inventory-messaging',
		data: {
			catalog,
			sku: skuStripped,
			stock: inStock,
			price,
			quantity,
			inventoryWarehouseId,
			inventoryCustomerId,
		},
		success(message) {
			if (!message) {
				return;
			}

			const responseInventoryMessage = getInventoryMessage(message);
			const responseShippingMessage = getShippingMessage(message);
			const responseShippingMessageTitle = getShippingMessageTitle(message);
			const responseShippingEstimateMessage = getShippingEstimateMessage(message);
			const responsePickupMessage = getPickupMessage(message);
			const responseInventoryType = message.inventoryMessageType || '';

			$container.find('#rp_inventory_message').html(responseInventoryMessage);
			$container.find('#rp_shipping_message').html(responseShippingMessage);
			$container.find('.shipping-message-title').html(responseShippingMessageTitle);
			$container.find('#rp_shipping_estimate_message').html(responseShippingEstimateMessage);
			$container.find('#rp_pickup_message').html(responsePickupMessage);

			const $inventoryWrap = $container.find('#inventory_wrap');
			$inventoryWrap.removeClass('inventory-out-of-stock');
			if (responseInventoryType === 'OutOfStockMessagingOnly') {
				$inventoryWrap.addClass('inventory-out-of-stock');
			}

			$container.find('.shipping-message-section').attr('hidden', responseShippingEstimateMessage === '' && responseShippingMessage === '');
			$container.find('#rp_shipping_message').attr('hidden', responseShippingMessage === '');
			$container.find('#rp_shipping_estimate_message').attr('hidden', responseShippingEstimateMessage === '');
			$container.find('.shipping-estimate-message-helptext').attr('hidden', responseShippingEstimateMessage === '');
			$container.find('.pickup-message-section').attr('hidden', responsePickupMessage === '');
			$inventoryWrap.attr('hidden', responseInventoryMessage === '');

			if (responseShippingEstimateMessage !== '') {
				const responseCustomerId = getInventoryMessageCustomerId(message);
				const responseWarehouseId = getInventoryMessageWarehouseId(message);
				$container.find('#rp_shipping_estimate_message').attr('data-inventory-warehouse-id', responseWarehouseId);
				$container.find('#rp_shipping_estimate_message').attr('data-inventory-warehouse-customer-id', responseCustomerId);
			}

			const $inStockBadge = $container.find('.badge-instock');
			const $shippingIcon = $container.find('.shipping-icon');
			if (responseInventoryMessage !== '') {
				$inStockBadge.attr('hidden', false);
				$shippingIcon.attr('hidden', false);
			}
		},
	});
}

/** @param {JQuery|HTMLElement|undefined} root Scope to a subtree when set; otherwise the document. */
function loadFitmentConfirmationWrappers(root) {
	const $root = root ? rp$(root) : rp$(document);
	const $wrappers = $root.find('.fitment-confirmation-component-ajax-wrapper');

	if ($wrappers.length === 0) {
		return;
	}

	$wrappers.each(function loadFitmentConfirmationWrapper() {
		const $target = rp$(this);
		const catalog = $target.data('catalog');
		const mpn = $target.data('mpn');

		if (!catalog || !mpn) {
			return;
		}

		const productPageUrl = globalThis.location.pathname;
		const inlineChangeLinkAttr = $target.attr('data-inline-change-link');
		const inlineChangeLink = inlineChangeLinkAttr !== '0' && inlineChangeLinkAttr !== 'false';
		const inventoryProductAttr = $target.attr('data-inventory-product');
		const inventoryProduct = inventoryProductAttr ? JSON.parse(inventoryProductAttr) : [];
		const encodedInventory = encodeURIComponent(JSON.stringify(inventoryProduct));

		$ajax({
			method: 'GET',
			dataType: 'json',
			url: `/ajax/product/${encodeURIComponent(catalog)}/${encodeURIComponent(mpn)}/fits-my-vehicle`,
			data: {
				productPageUrl,
				inlineChangeLink: inlineChangeLink ? '1' : '0',
				inventoryProduct: encodedInventory,
			},
			cache: false,
			success(response) {
				if (response?.html) {
					$target.html(response.html);
					trackWrongCarSelectedIfApplicable($target);
					loadInventoryMessages($target);
				}
			},
			error() {
				$target.empty();
			},
		});
	});
}

module.exports = {
	loadFitmentConfirmationWrappers,
};
